// Domain Configuration for PadelMaster
// This file centralizes all domain-related configurations

export const DOMAIN_CONFIG = {
  // Production domains
  PRODUCTION_PRIMARY: 'padelmaster.club',
  PRODUCTION_SECONDARY: 'padelmas.club',
  
  // Staging domains
  STAGING: 'staging.padelmaster.club',
  STAGING_ALT: 'staging.padelmas.club',
  
  // Development
  DEVELOPMENT: 'localhost',
  DEVELOPMENT_PORT: '5173',
  
  // API endpoints
  API_PRODUCTION: 'https://padelmasterclub-production.up.railway.app',
  API_STAGING: 'https://api.staging.padelmaster.club',
  API_DEVELOPMENT: 'http://localhost:8000',
};

// Helper functions for domain detection
export const isDevelopment = (): boolean => {
  const hostname = window.location.hostname;
  return hostname === DOMAIN_CONFIG.DEVELOPMENT || 
         hostname === '127.0.0.1' || 
         hostname.startsWith('192.168.');
};

export const isStaging = (): boolean => {
  const hostname = window.location.hostname;
  return hostname === DOMAIN_CONFIG.STAGING || 
         hostname === DOMAIN_CONFIG.STAGING_ALT ||
         hostname.includes('staging');
};

export const isProduction = (): boolean => {
  const hostname = window.location.hostname;
  return hostname === DOMAIN_CONFIG.PRODUCTION_PRIMARY || 
         hostname === DOMAIN_CONFIG.PRODUCTION_SECONDARY ||
         hostname.includes('padelmaster') ||
         hostname.includes('padelmas');
};

export const isOfficialDomain = (): boolean => {
  return isProduction() || isStaging();
};

export const getCurrentEnvironment = (): 'development' | 'staging' | 'production' => {
  if (isDevelopment()) return 'development';
  if (isStaging()) return 'staging';
  return 'production';
};

export const getApiUrl = (): string => {
  const env = getCurrentEnvironment();
  switch (env) {
    case 'development':
      return DOMAIN_CONFIG.API_DEVELOPMENT;
    case 'staging':
      return DOMAIN_CONFIG.API_STAGING;
    case 'production':
      return DOMAIN_CONFIG.API_PRODUCTION;
    default:
      return DOMAIN_CONFIG.API_PRODUCTION;
  }
};

export const getOfficialDomainName = (): string => {
  return DOMAIN_CONFIG.PRODUCTION_PRIMARY;
};

// Console-specific domain checks
export const shouldShowProductionBanner = (): boolean => {
  return isProduction();
};

export const shouldShowStagingBanner = (): boolean => {
  return isStaging();
};

export const shouldShowDevelopmentBanner = (): boolean => {
  return isDevelopment();
};

// Security checks
export const validateDomainSecurity = (): {
  isSecure: boolean;
  isOfficial: boolean;
  warnings: string[];
} => {
  const warnings: string[] = [];
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // Check if HTTPS in production
  if (isProduction() && protocol !== 'https:') {
    warnings.push('Site de produção deveria usar HTTPS');
  }
  
  // Check for suspicious domains
  if (hostname.includes('padelmaster') && !isOfficialDomain()) {
    warnings.push('Domínio suspeito detectado');
  }
  
  return {
    isSecure: protocol === 'https:' || isDevelopment(),
    isOfficial: isOfficialDomain(),
    warnings
  };
};

export default DOMAIN_CONFIG;
